import React from "react";
import Lottie from "react-lottie";

export default function LottieAnimation({ lotti, width, height, isloop }) {
  const defaultOptions = {
    loop: isloop,
    autoplay: true,
    animationData: lotti,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div>
      <Lottie options={defaultOptions} height={height} width={width} />
    </div>
  );
};
